import { login, logout, getInfo, getRouteAuthReq } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import Vue from 'vue'
let $vue = new Vue();
// import { resetRouter } from '@/router'
import {
	dataComponentTrans,
	jsonToArray,
	filterIndexVue,
	jsonToArrayDel,
	uniqueList,
	trimTreeExceedThreeLevels
} from '@/router/routePathTrans'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    roleId: '',
    loginData: null
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLE: (state, roleId) => {
    state.roleId = roleId
  },
  SET_LOGIN_DATA: (state, data) => {
    state.loginData = data
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, account, realName } = userInfo
    return new Promise((resolve, reject) => {
      login({ ...userInfo, username: username.trim(), account, realName }).then(response => {
        if (response.statusCode === 500) {
          $vue.$dialog({
            title: '温馨提示',
            content: response.message,
            footBtn: false,
            width: '20%',
            dialogType: 'warning',
          })
        }

        const { data } = response
        if (data && data.partnershipType !== undefined) {
          localStorage.setItem('partnershipType', data.partnershipType);
        }
        if (data && data.token) {
          commit('SET_TOKEN', data.token)
          setToken(data.token)
        }
        commit('SET_LOGIN_DATA', data)
        resolve(response)
      }).catch(error => {
        reject(error, "???")
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          return reject('Verification failed, please Login again.')
        }

        const { fullname, role } = data
        commit('SET_ROLE', role)
        commit('SET_NAME', fullname)
        // commit('SET_AVATAR', avatar)
        resolve(data)
      }).catch(error => {

        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // must remove  token  first
        // resetRouter()
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE', '')
      resolve()
    })
  },

  // 获取路由权限
  getRouteAuth ({ commit, state }) {
    return new Promise((resolve, reject) => {
      getRouteAuthReq().then(response => {
        const { data } = response
        if (!data) {
          return reject('Verification failed, please Login again.')
        }
        // 复制请求结果原始数据
        const copyData = JSON.parse(JSON.stringify(data))
        // 将请求结果原始数据转为一维数组
        const pageListData = jsonToArray(copyData)
        const filterData = filterIndexVue(pageListData)
        const jsonToArrayDelData = jsonToArray(filterData)
        const newFilterData = filterIndexVue(jsonToArrayDelData)
        const uniqueData = uniqueList(newFilterData, 'name')
        const lastPageData = trimTreeExceedThreeLevels(uniqueData)
        // 找到数据的对应组件
        dataComponentTrans(lastPageData)
        // console.log('lastPageData', lastPageData)
        resolve({data, lastPageData})
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js